import React, { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { BeforeAfter } from "@/components/BeforeAfter";
import { Reviews } from "@/components/Reviews";
import { Gallery } from "@/components/Gallery";
import { About } from "@/components/About";
import { ServiceAreas } from "@/components/ServiceAreas";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { CallFab } from "@/components/CallFab";
import CityPage from "@/pages/CityPage";
import AdminPricing from "@/pages/AdminPricing";
import { useSEO } from "@/lib/useSEO";
import { SITE } from "@/lib/site";

const Home = () => {
  const contactRef = useRef(null);
  const scrollToQuote = () =>
    contactRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });

  useSEO({
    title: "ClearView Pressure Washing — Ohio | 5-Star House, Driveway & Gutter Cleaning",
    description:
      "Professional pressure washing across Ohio. Soft-wash siding, driveway cleaning, and gutter clean-outs. 5.0 stars on Google. Free quotes — call (234) 233-9716.",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "ClearView Pressure Washing",
      image: "https://customer-assets.emergentagent.com/job_clearview-services/artifacts/aimy9eyc_IMG_4194.jpeg",
      telephone: SITE.phone,
      email: SITE.email,
      areaServed: { "@type": "State", name: "Ohio" },
      address: { "@type": "PostalAddress", addressRegion: "OH", addressCountry: "US" },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: SITE.rating,
        reviewCount: SITE.reviewCount,
      },
      priceRange: "$$",
      sameAs: [],
    },
  });

  return (
    <div className="bg-white text-slate-900 antialiased">
      <Header onQuoteClick={scrollToQuote} />
      <main>
        <Hero onQuoteClick={scrollToQuote} />
        <Services onQuoteClick={scrollToQuote} />
        <BeforeAfter />
        <Reviews />
        <Gallery />
        <About />
        <ServiceAreas />
        <QuoteForm ref={contactRef} />
      </main>
      <Footer />
      <CallFab />
      <Toaster richColors position="top-center" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/areas/:slug" element={<CityPage />} />
          <Route path="/admin/pricing" element={<AdminPricing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
